import React from "react";
import {ChannelType} from "../Types/ChannelType";

const ChannelContext = React.createContext<ChannelType|null>(null);

export {ChannelContext};
